import React, { useEffect, useRef, Fragment } from "react";
import { Link } from "react-router-dom";

import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import GetStarted from "components/Sections/GetStarted";
import AppNavbar from "components/Navbars/AppNavbar";
import SimpleFooter from "components/Footers/SimpleFooter";

export default function Index(props) {

    const mainEl = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainEl.current.scrollTop = 0;

        document.title = "Club Apps | A new way to Manage your Membership"
        document.querySelector('meta[name="description"]').setAttribute("content", "We are the standard in Club and Organization Software offering a feature rich application for administrators and a fast, intuitive front end for members and guests.");
        
    }, []);

    return (
        <Fragment>
            <AppNavbar white/>
            <main ref={mainEl}>
                <section className="section section-xl section-shaped pb-250">
                    <div className="index-background-container"/>
                    <Container className="py-lg-md d-flex">
                        <div className="col px-0">
                            <Row>
                                <Col md="6">
                                    <h1 className="display-3">
                                        Your membership, managed.
                                    </h1>
                                    <p className="lead">
                                        Managing an organization can be a time-consuming task, but it doesn’t have to be. Club Apps offers a cloud based member relations platform that does the heavy lifting for you.
                                    </p>
                                    <div className="btn-wrapper">
                                        <Button
                                            className="mb-3 mb-sm-0 mr-2"
                                            color="success"
                                            href="https://clubapps.org/register"
                                            >
                                            <span className="btn-inner--text">Get Started</span>
                                        </Button>
                                        <Button
                                            className="btn-white mb-3 mb-sm-0"
                                            color="default"
                                            to="/contact/sales"
                                            tag={Link}
                                            >
                                            <span className="btn-inner--text">
                                                Contact Sales
                                            </span>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section mt--200 d-none d-lg-block">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg="12">
                                <Row className="row-grid">
                                    <Col lg="4">
                                        <Card className="shadow shadow-lg--hover">
                                            <CardBody className="py-5">
                                                <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                                                    <i className="ni ni-app" />
                                                </div>
                                                <h6 className="text-primary text-uppercase">
                                                    PRODUCT OVERVIEW
                                                </h6>
                                                <p className="description mt-3">
                                                    Club Apps offers a fast-secure platform to conduct all your membership business and social needs.
                                                </p>
                                                <Button
                                                    className="mt-4"
                                                    outline
                                                    color="primary"
                                                    to="/overview"
                                                    tag={Link}
                                                    >
                                                    Learn more
                                                </Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card className="shadow shadow-lg--hover">
                                            <CardBody className="py-5">
                                                <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                                                    <i className="ni ni-spaceship" />
                                                </div>
                                                <h6 className="text-success text-uppercase">
                                                    FEATURE RICH
                                                </h6>
                                                <p className="description mt-3">
                                                    Learn about how our flagship application's features can help launch your organization into the future.
                                                </p>
                                                <Button
                                                    className="mt-4"
                                                    outline
                                                    color="success"
                                                    to="/features"
                                                    tag={Link}
                                                    >
                                                    Features
                                                </Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card className="shadow shadow-lg--hover">
                                            <CardBody className="py-5">
                                                <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                                                    <i className="ni ni-bulb-61" />
                                                </div>
                                                <h6 className="text-warning text-uppercase">
                                                    GET SOME HELP
                                                </h6>
                                                <p className="description mt-3">
                                                    Browse our help topics to quickly answer a question or find out how to contact our support team.
                                                </p>

                                                <Button
                                                    className="mt-4"
                                                    outline
                                                    color="warning"
                                                    href="https://support.clubapps.org/"
                                                    target="_blank"
                                                    title="Visit our Support Center"
                                                    >
                                                    Support Center
                                                </Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section">
                    <Container className="pb-5">
                        <Row className="row-grid align-items-center">
                            <Col className="order-md-2 text-center d-none d-md-block" md="6">
                                <img
                                    alt="A Unified User Experience"
                                    className="img-fluid floating"
                                    src={require("assets/images/unified-user-experience.jpg")}
                                />
                            </Col>
                            <Col className="order-md-1" md="6">
                                <div className="pr-md-5">
                                    <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                                        <i className="ni ni-circle-08" />
                                    </div>
                                    <h3>Unified User Experience</h3>
                                    <p>
                                        Using email authentication to verify ownership, your members will no longer need multiple accounts for each organization they are associated with.
                                    </p>
                                    <ul className="list-unstyled mt-5">
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <Badge
                                                        className="badge-circle mr-3"
                                                        color="success"
                                                        >
                                                        1
                                                    </Badge>
                                                </div>
                                                <div>
                                                    <h6 className="mb-0">Verify your email</h6>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <Badge
                                                        className="badge-circle mr-3"
                                                        color="success"
                                                        >
                                                        2
                                                    </Badge>
                                                </div>
                                                <div>
                                                    <h6 className="mb-0">Reconcile associated accounts</h6>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <Badge
                                                        className="badge-circle mr-3"
                                                        color="success"
                                                        >
                                                        3
                                                    </Badge>
                                                </div>
                                                <div>
                                                    <h6 className="mb-0">Enjoy all your clubs with one profile</h6>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section bg-secondary">
                    <Container className="pb-5">
                        <Row className="row-grid align-items-center">
                            <Col className="text-center d-none d-md-block" md="6">
                                <img
                                    alt="Start Accepting Payments with Stripe"
                                    className="img-fluid"
                                    src={require("assets/images/accept-payments.png")}
                                />
                            </Col>
                            <Col md="6">
                                <div className="pl-md-5">
                                    <div className="icon icon-lg icon-shape icon-shape-primary shadow rounded-circle mb-5">
                                        <i className="ni ni-credit-card" />
                                    </div>
                                    <h3>Accept Payments</h3>
                                    <p className="lead">
                                        Start accepting payments online in a matter of minutes using our integrated payment platform.
                                    </p>
                                    <p>
                                        We have partnered with <a href="https://stripe.com" target="_blank">Stripe</a> to bring our clubs and organizations unparalleled flexibility and speed when accepting payments online.
                                    </p>
                                    <p>
                                        Automate membership dues invoicing, ticket sales and more. You can easily view your account balance, transaction history and analytics from the accounting dashboard. Trasfer your balance to a connected bank account for free in 2 - 3 business days, or instantly for a small fee.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section">
                    <div className="material-design-background-container"/>
                    <Container className="pb-5">
                        <Row className="row-grid align-items-center">
                            <Col className="order-md-2 d-none d-md-block" md="6">
                                <div className="rounded shadow-lg overflow-hidden transform-perspective-right">
                                    <img
                                        alt="Modern Design Form"
                                        className="img-fluid"
                                        src={require("assets/images/material-design-form.jpg")}
                                    />
                                </div>
                            </Col>
                            <Col className="order-md-1" md="6">
                                <div className="pr-md-5">
                                    <div className="icon icon-lg icon-shape bg-white text-primary shadow rounded-circle mb-5">
                                        <i className="ni ni-ruler-pencil" />
                                    </div>
                                    <h3 className="text-white">Modern Design</h3>
                                    <p className="lead text-white">
                                        Our application follows material design standards and is both familiar and functional for your members and administrators. We strive to make our user interface as simple and straight-forward as possible.
                                    </p>

                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section bg-secondary">
                    <Container className="pb-5">
                        <Row className="row-grid align-items-center">
                            <Col md="6">
                                <img
                                    alt="Dedicated Support"
                                    className="img-fluid"
                                    src={require("assets/images/dedicated-support.png")}
                                />
                            </Col>
                            <Col md="6">
                                <Card className="shadow shadow-lg--hover">
                                    <CardBody>
                                        <div className="d-flex px-3">
                                            <div className="d-none d-sm-block">
                                                <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                                                    <i className="ni ni-satisfied" />
                                                </div>
                                            </div>
                                            <div className="pl-0 pl-sm-4">
                                                <h5 className="title text-success">
                                                    Always Improving
                                                </h5>
                                                <p>
                                                    With seamless daily updates, our systems are always improving. We are constantly expanding the applications features and allow clubs to beta test new features by request. Never expect a bug to pester around for too long.
                                                </p>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                                <Card className="shadow shadow-lg--hover mt-5">
                                    <CardBody>
                                        <div className="d-flex px-3">
                                            <div className="d-none d-sm-block">
                                                <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                                    <i className="ni ni-support-16" />
                                                </div>
                                            </div>
                                            <div className="pl-0 pl-sm-4">
                                                <h5 className="title text-warning">Dedicated Support</h5>
                                                <p>
                                                    Our account managers work with club and organization administrators directly, offering guaranteed response times with no added costs. Monthly subscriptions offer dedicated account managers and more.
                                                </p>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <GetStarted newsletter/>
            </main>
            <SimpleFooter />
        </Fragment>
    );
}
